import {Action} from '@ngrx/store';
import * as _ from 'lodash';

import {UserContextActionTypes} from '../../shared';
import {
  AudioPlanningsActionTypes,
  LoadAudioPlanningsSuccessAction,
  ToggleAudioPlanningsPlayAction,
  ToggleSearchAudioPlanningsAction
} from '../actions/audio-plannings';
import {AudioPlanning} from '../models/audio-planning';

export interface AudioPlanningsState {
  showFilter: boolean;
  array: AudioPlanning[];
  count: number;
  playing: string;
}

const initialState: AudioPlanningsState = {
  showFilter: false,
  array: [],
  count: 0,
  playing: undefined
};

export function audioPlanningsReducer(state = initialState, action: Action): AudioPlanningsState {
  switch (action.type) {
    case AudioPlanningsActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case AudioPlanningsActionTypes.CLEAR:
      return handleClearAction(state);
    case AudioPlanningsActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case AudioPlanningsActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    case UserContextActionTypes.CHANGE_CLIENT:
      return handleChangeClientAction();
    case AudioPlanningsActionTypes.TOGGLE_PLAY:
      return handleTogglePlayAction(state, action);
    default:
      return state;
  }
}

function handleToggleSearchAction(state: AudioPlanningsState, action: ToggleSearchAudioPlanningsAction): AudioPlanningsState {
  const newState: AudioPlanningsState = { showFilter: action.payload, array: state.array, count: state.count, playing: state.playing };
  return newState;
}

function handleClearAction(state: AudioPlanningsState): AudioPlanningsState {
  const newState: AudioPlanningsState = { showFilter: state.showFilter, array: [], count: 0, playing: undefined };
  return newState;
}

function handleLoadSuccessAction(state: AudioPlanningsState, action: LoadAudioPlanningsSuccessAction): AudioPlanningsState {
  const newState: AudioPlanningsState = { showFilter: state.showFilter, array: action.payload.array, count: action.payload.count, playing: undefined };
  return newState;
}

function handleLoadFailAction(state: AudioPlanningsState): AudioPlanningsState {
  const newState: AudioPlanningsState = { showFilter: state.showFilter, array: [], count: 0, playing: undefined };
  return newState;
}

function handleChangeClientAction(): AudioPlanningsState {
  // !!! this showFilter override all showFilter
  return { showFilter: false, array: [], count: 0, playing: undefined };
}

function handleTogglePlayAction(state: AudioPlanningsState, action: ToggleAudioPlanningsPlayAction): AudioPlanningsState {
  if (state.playing === action.payload) {
    return {...state, playing: undefined };
  } else {
    return {...state, playing: action.payload };
  }
}

export const audioPlanningsSelectors = {
  showFilter: (state: AudioPlanningsState) => _.get(state, 'showFilter', false),
  array: (state: AudioPlanningsState) => _.get(state, 'array', []),
  count: (state: AudioPlanningsState) => _.get(state, 'count', 0),
  playing: (state: AudioPlanningsState) => _.get(state, 'playing')
};
